module.exports = __webpack_public_path__ + "img/05-SiteQuiz-01.acd773f0.png";